/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppButton from '../../shared/components/app-button/AppButton';
import './ManageBookingPage.scss';
import {
  getTransactionByParams,
  getTransactionDetails,
} from '../../api/profileApi';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import ManageFlightBooking from './ManageFlightBooking';
import ManageBusBooking from './ManageBusBooking';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppSelect from '../../shared/components/app-select/AppSelect';
import {
  formatDate,
  getNewDate,
  isEmpty,
} from '../../shared/helper-utils/appUtils';
import ManageFlightCancellation from './ManageFlightCancellation';
import { API_DATE_FORMAT, TODAY_DATE } from '../../shared/constants/Constants';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import AccountsPageHorizontalBar from '../profile/accounts/AccountsPageHorizontalBar';

const TX_TYPE_OPTIONS = [
  { label: 'Flight Bookings', value: 'FLTBKG' },
  { label: 'Flight Cancellations', value: 'FLTCANX' },
  // { label: 'Credit Debit Notes', value: 'CREDITDEBIT' },
  // { label: 'Receipts', value: 'RECEIPTS' },
];

function ManageAllBookings() {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [transactionId, setTransactionId] = useState('');
  const [txType, setTxType] = useState(undefined);
  const [record, setRecord] = useState(undefined);
  const [hasRecord, setHasRecord] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTxType, setSelectedTxType] = useState('');
  const [searchParams, setSearchParams] = useState({
    bookingdate: '',
    gdspnr: '',
    airlinepnr: '',
    paxinfo: '',
    jdate: '',
    flightticketnums: '',
    reference_txid: '',
    remarks: '',
    txdate: '',
  });
  const [transactionList, setTransactionsList] = useState([]);
  const [isSearchDone, setIsSearchDone] = useState(undefined);

  const handleUpdateSearchParams = (event) => {
    const { name, value } = event.target;
    setSearchParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTxTypeSelect = (obj) => {
    if (obj) {
      setSelectedTxType(obj.value);
    } else {
      setSelectedTxType('');
    }
    setIsSearchDone(false);
    setSearchParams({
      bookingdate: '',
      gdspnr: '',
      airlinepnr: '',
      paxinfo: '',
      jdate: '',
      flightticketnums: '',
      reference_txid: '',
      remarks: '',
      txdate: '',
    });
  };

  const handlegetBookingByTxid = async () => {
    setIsLoading(true);
    if (transactionId !== '' && transactionId !== undefined) {
      const response = await getTransactionDetails(transactionId);
      if (response?.Root?.Status === 'OK') {
        const { Message } = response.Root;
        setTxType(Message);
        if (Message === 'FLTBKG') {
          const { FlightRecord } = response.Root.Result;
          if (!isEmpty(FlightRecord)) {
            const list = Array.isArray(FlightRecord)
              ? FlightRecord
              : [FlightRecord];
            setTransactionsList(list);
            setIsSearchDone(true);
          }
        } else if (Message === 'FLIGHTCANX') {
          const { FlightCancellation } = response.Root.Result;
          if (!isEmpty(FlightCancellation)) {
            const list = Array.isArray(FlightCancellation)
              ? FlightCancellation
              : [FlightCancellation];
            setTransactionsList(list);
            setIsSearchDone(true);
          }
        }
      } else {
        setAlert({
          variant: 'error',
          title: formattedMessage('manage_bookings'),
          description: response.Root.Message,
        });
        setHasRecord(false);
      }
    } else {
      setHasRecord(false);
    }
    setIsLoading(false);
  };

  const getFlightBookingList = async () => {
    setIsLoading(true);
    const {
      bookingdate,
      gdspnr,
      airlinepnr,
      paxinfo,
      jdate,
      flightticketnums,
    } = searchParams;
    const req = {
      bookingdate,
      gdspnr,
      airlinepnr,
      paxinfo,
      jdate,
      flightticketnums,
    };
    const res = await getTransactionByParams(
      transactionId,
      selectedTxType,
      req,
    );
    if (res && res.Root && res.Root.Status === 'OK') {
      setIsSearchDone(true);
      if (!isEmpty(res?.Root?.Result)) {
        const { FlightResult } = res.Root.Result;
        if (!isEmpty(FlightResult)) {
          const { FlightRecord } = FlightResult;
          if (!isEmpty(FlightRecord)) {
            const list = Array.isArray(FlightRecord)
              ? FlightRecord
              : [FlightRecord];
            setTransactionsList(list);
          }
        }
      }
    } else {
      setAlert({
        variant: 'error',
        title: formattedMessage('manage_bookings'),
        description: res?.Root?.Message,
      });
    }
    setIsLoading(false);
  };
  const getFligthCancellationsList = async () => {
    setIsLoading(true);
    const { txdate, reference_txid, remarks, gdspnr, flightticketnums } =
      searchParams;
    const req = {
      txdate,
      reference_txid,
      remarks,
      gdspnr,
      flightticketnums,
    };
    const res = await getTransactionByParams(
      transactionId,
      selectedTxType,
      req,
    );
    if (res && res.Root && res.Root.Status === 'OK') {
      setIsSearchDone(true);
      if (!isEmpty(res?.Root?.Result)) {
        const { FlightCanxResult } = res.Root.Result;
        if (!isEmpty(FlightCanxResult)) {
          const { FlightCancellation } = FlightCanxResult;
          if (!isEmpty(FlightCancellation)) {
            const list = Array.isArray(FlightCancellation)
              ? FlightCancellation
              : [FlightCancellation];
            setTransactionsList(list);
          }
        }
      }
    } else {
      setAlert({
        variant: 'error',
        title: formattedMessage('manage_bookings'),
        description: res?.Root?.Message,
      });
    }
    setIsLoading(false);
  };

  const handleSearch = async () => {
    if (isEmpty(transactionId) && isEmpty(selectedTxType)) {
      setAlert({
        variant: 'error',
        title: 'Manage Bookings',
        description: 'Please enter Transaction ID or select Tx Type',
      });
      return;
    }
    setTransactionsList([]);
    switch (selectedTxType) {
      case 'FLTBKG':
        await getFlightBookingList();
        break;
      case 'FLTCANX':
        await getFligthCancellationsList();
        break;
      default:
        await handlegetBookingByTxid();
        break;
    }
  };

  return (
    <section className="manage-all-bookings">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <AccountsPageHorizontalBar selectedPage="manage-bookings" />
      <section className="manage-all-bookings_container">
        <div className="manage-all-bookings_heading">Manage Bookings</div>
        <div className="manage-all-bookings_content p-3">
          <div className="content-header mb-3 fs-16">
            {formattedMessage('search_all_transactions')}
          </div>
          <div className="manage-all-bookings_container_content">
            <Row className="spacing-8 mb-2">
              <Col lg={3} md={4} sm={4} xs={12}>
                <AppTextInput
                  label={formattedMessage('transaction_id')}
                  name="transactionId"
                  value={transactionId}
                  onChange={(e) => setTransactionId(e.target.value)}
                />
              </Col>
              <Col lg={3} md={4} sm={4} xs={12}>
                <AppSelect
                  name="txtype"
                  className="fs-14"
                  options={TX_TYPE_OPTIONS}
                  placeholder=""
                  label="Tx Type"
                  onSelect={handleTxTypeSelect}
                  selectedValue={selectedTxType}
                />
              </Col>
              <Col lg={3} md={4} sm={4} xs={12}>
                <AppButton
                  btnText={formattedMessage('search')}
                  className="w-100"
                  onClick={handleSearch}
                />
              </Col>
            </Row>
            {selectedTxType !== '' && (
              <Row className="spacing-8 my-2">
                {selectedTxType === 'FLTBKG' && (
                  <>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <AppDatePicker
                        label="Booking Date"
                        name="bookingdate"
                        className="app-date-picker"
                        customClassName="position-relative flight-booking-picker "
                        placeholder=""
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        disabledKeyboardNavigation
                        selectedDate={
                          !isEmpty(searchParams.bookingdate) &&
                          getNewDate(searchParams.bookingdate)
                        }
                        onChange={(date) =>
                          handleUpdateSearchParams({
                            target: {
                              name: 'bookingdate',
                              value: formatDate(
                                getNewDate(date),
                                API_DATE_FORMAT,
                              ),
                            },
                          })
                        }
                        labelClassName="booking-date-label"
                      />
                    </Col>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <AppTextInput
                        label="GDS PNR"
                        name="gdspnr"
                        value={searchParams.gdspnr}
                        onChange={handleUpdateSearchParams}
                      />
                    </Col>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <AppTextInput
                        label="Airline PNR"
                        name="airlinepnr"
                        value={searchParams.airlinepnr}
                        onChange={handleUpdateSearchParams}
                      />
                    </Col>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <AppTextInput
                        label="Pax Info"
                        name="paxinfo"
                        value={searchParams.paxinfo}
                        onChange={handleUpdateSearchParams}
                      />
                    </Col>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <AppDatePicker
                        label="Journey Date"
                        name="jdate"
                        className="app-date-picker"
                        customClassName="position-relative flight-booking-picker "
                        placeholder=""
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        disabledKeyboardNavigation
                        selectedDate={
                          !isEmpty(searchParams.jdate) &&
                          getNewDate(searchParams.jdate)
                        }
                        onChange={(date) =>
                          handleUpdateSearchParams({
                            target: {
                              name: 'jdate',
                              value: formatDate(
                                getNewDate(date),
                                API_DATE_FORMAT,
                              ),
                            },
                          })
                        }
                        labelClassName="booking-date-label"
                      />
                    </Col>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <AppTextInput
                        label="Ticket Numbers"
                        name="flightticketnums"
                        value={searchParams.flightticketnums}
                        onChange={handleUpdateSearchParams}
                      />
                    </Col>
                  </>
                )}
                {selectedTxType === 'FLTCANX' && (
                  <>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <AppDatePicker
                        label="Tx Date"
                        name="txdate"
                        className="app-date-picker"
                        customClassName="position-relative flight-booking-picker "
                        placeholder=""
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        disabledKeyboardNavigation
                        selectedDate={
                          !isEmpty(searchParams.txdate) &&
                          getNewDate(searchParams.txdate)
                        }
                        onChange={(date) =>
                          handleUpdateSearchParams({
                            target: {
                              name: 'txdate',
                              value: formatDate(
                                getNewDate(date),
                                API_DATE_FORMAT,
                              ),
                            },
                          })
                        }
                        labelClassName="booking-date-label"
                      />
                    </Col>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <AppTextInput
                        label="Reference Tx ID"
                        name="reference_txid"
                        value={searchParams.reference_txid}
                        onChange={handleUpdateSearchParams}
                      />
                    </Col>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <AppTextInput
                        label="Remarks"
                        name="remarks"
                        value={searchParams.remarks}
                        onChange={handleUpdateSearchParams}
                      />
                    </Col>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <AppTextInput
                        label="PNR"
                        name="gdspnr"
                        value={searchParams.gdspnr}
                        onChange={handleUpdateSearchParams}
                      />
                    </Col>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <AppTextInput
                        label="Ticket Numbers"
                        name="flightticketnums"
                        value={searchParams.flightticketnums}
                        onChange={handleUpdateSearchParams}
                      />
                    </Col>
                  </>
                )}
              </Row>
            )}
          </div>
        </div>
      </section>
      {isSearchDone && (
        <div className="max-width mt-3">
          {transactionList &&
            transactionList.length > 0 &&
            (selectedTxType === 'FLTBKG' || txType === 'FLTBKG') && (
              <ManageFlightBooking flightRecord={transactionList} />
            )}
          {transactionList &&
            transactionList.length > 0 &&
            (selectedTxType === 'FLTCANX' || txType === 'FLIGHTCANX') && (
              <ManageFlightCancellation flightRecord={transactionList} />
            )}
        </div>
      )}
    </section>
  );
}

export default ManageAllBookings;
